"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TealiumTracker = void 0;
/* eslint-disable no-console */
const tracker_1 = require("../tracker");
class TealiumTracker extends tracker_1.Tracker {
    constructor(config, objectKeyFormatter = null) {
        super(config, objectKeyFormatter);
        this.id = 'tealium';
        this.sendInfo = (data) => {
            if (this.isViewTagView(data)) {
                this.dispatchViewEvent(data);
            }
            else {
                this.dispatchLinkEvent(data);
            }
        };
    }
    isViewTagView(data) {
        return data.pageName !== undefined;
    }
    dispatchLinkEvent(data) {
        var _a;
        (_a = window.utag) === null || _a === void 0 ? void 0 : _a.link(this.parseData(data));
    }
    dispatchViewEvent(data) {
        var _a;
        (_a = window.utag) === null || _a === void 0 ? void 0 : _a.view(this.parseData(data));
    }
}
exports.TealiumTracker = TealiumTracker;
//# sourceMappingURL=tealiumTracker.js.map